<div class="page-body">
    <h1>Купите «Виртуальные лаборатории» для себя или своей школы прямо сейчас!</h1>
    <h2>Условия предоставления прав на программное обеспечение</h2>
    <p>
        Программное обеспечение «Виртуальные лаборатории» поставляется по модели SaaS (англ.
        software as a service – программное обеспечение как услуга), т.е. не ставится на отдельный
        компьютер, а загружается только из интернета, через web-браузер. У каждого пользователя есть
        свой личный кабинет, где он хранит свои загруженные сцены и может обмениваться ими с другими
        пользователями.
    </p>
    <p>
        Права на программное обеспечение «Виртуальные лаборатории» (персональная лицензия)
        приобретается на каждого пользователя – учителя или ученика отдельно, для использования со
        школьного и домашнего компьютера. Использование одной приобретенной подписки несколькими
        пользователями не допускается.
    </p>
    <p>
        Вы можете приобрести права на программное обеспечение «Виртуальные лаборатории» двумя
        способами.
    </p>
    <ol>
        <li class="list-title">С ПОМОЩЬЮ ОНЛАЙН-ПЛАТЕЖА</li>
        <p>
            Этот способ подходит для частных лиц, ИП и организаций, у которых есть возможность
            оплатить с помощью корпоративной карты.
        </p>
        <p>
            Приобрести права вы можете на
            <a href="https://portal.vr-labs.ru/" target="_blank"
                >портале «Виртуальные лаборатории»</a
            >.
        </p>
        <li class="list-title">С ПОМОЩЬЮ ЛИЦЕНЗИОННОГО ДОГОВОРА</li>
        <p>
            Этот способ подходит для государственных, муниципальных или иных форм собственности
            организаций.
        </p>
        <p>
            Лицензионный договор предоставляет непередаваемое право использования программного
            обеспечения на условиях простой (неисключительной) лицензии с возможностью использовать
            программное обеспечение на всей территории Российской Федерации или любой страны мира.
        </p>
        <p>
            Цены на программное обеспечение (стоимость лицензий) и Сертификаты технической поддержки
            предоставляются в виде официального коммерческого предложения по предварительному
            запросу на e-mail: sale&#64;answer-42.ru.
        </p>
        <p>
            Стоимость программного обеспечения (стоимость лицензий) и Сертификатов технической
            поддержки определяется по запросу, в зависимости от запрашиваемых характеристик и
            количества персональных лицензий.
        </p>
        <p>
            Для получения подробной информации о технических характеристиках программного
            обеспечения, пожалуйста, обращайтесь к нам любым иным способом связи, указанным ниже на
            странице, в разделе «Контактная информация».
        </p>
    </ol>
    <h3>Условия предоставления прав на программное обеспечение</h3>
    <ol>
        <li>
            Передача лицензии по Лицензионному договору осуществляется в течение 5-10 рабочих дней с
            даты оплаты по заключенному договору. По факту передачи лицензии на право использования
            программного обеспечения составляется Акт приема-передачи лицензии. Технически передача
            лицензии осуществляется путем предоставления заказчику электронного доступа к
            лицензионному дистрибутиву, регистрационным данным и сопутствующей технической
            документации.
        </li>
        <li>
            Обращаем ваше внимание на то, что информация на данном интернет-сайте (answer-42.ru)
            носит исключительно информационный характер и ни при каких условиях не является
            публичной офертой, определяемой положениями Статьи 437 п.2 Гражданского кодекса РФ.
        </li>
        <li>
            Передача лицензии не облагается НДС на основании Федерального Закона №195-ФЗ от
            19.07.2007 по статье 149 п.2 пп.26 НК РФ с 01.01.2008 г. и при условии включения ПО в
            единый реестр российских программ для электронных вычислительных машин и баз данных (п.
            1 ФЗ-265 от 31.07.2020).
        </li>
        <li>
            Оставляя тем или иным способом свою персональную информацию на сайте, вы делегируете
            право сотрудникам компании ООО «42» обрабатывать вашу персональную информацию.
        </li>
        <li>
            Для аналитических целей на сайте работает система статистики, которая собирает
            информацию о посещенных страницах сайта, заполненных формах и т.д. Сотрудники компании
            имеют доступ к этой информации.
        </li>
    </ol>
</div>
